function invariant(cond, message) {
    if (!cond) throw new Error(message);
}

export { invariant };
//# sourceMappingURL=invariant.mjs.map
